import { render, staticRenderFns } from "./shipDetDate.vue?vue&type=template&id=573010b6"
import script from "./shipDetDate.vue?vue&type=script&lang=js"
export * from "./shipDetDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports